// extracted by mini-css-extract-plugin
export var filterIncDec = "_a5-0";
export var leftBorder = "_a5-1";
export var rightBorder = "_a5-2";
export var stringInput = "_a5-3";